/**
 * `learning-blocks` — motor de bloques de aprendizaje EXTENSIBLE de Space.
 *
 * Añadir un tipo de bloque nuevo = implementar `BlockPlugin` + `registry.register()`.
 * El motor (`gradeBlock`/`gradeLesson`) NUNCA cambia. Ver guía LEARNING_BLOCKS.
 */
export * from "./types";
export * from "./normalize";
export * from "./registry";
export * from "./engine";
export * from "./antifraud";
export * from "./blocks";

import { baseBlocks } from "./blocks";
import { BlockRegistry } from "./registry";

/** Registro con los 6 tipos base cargados. Punto de partida para la app. */
export function defaultRegistry(): BlockRegistry {
  return new BlockRegistry().registerAll(baseBlocks);
}
